'use client';

import type { ComponentProps } from 'react';
import StreamingHomePage from '../../StreamingHomePage';
import { NEW_2026_COMPONENT_MAP } from './component-map';

type New2026WapProps = Pick<
  ComponentProps<typeof StreamingHomePage>,
  'homeListData' | 'deviceType' | 'serverRenderPolicy'
>;

export default function NEW_2026_WAP_HomePage(props: New2026WapProps) {
  return <StreamingHomePage {...props} componentMap={NEW_2026_COMPONENT_MAP} />;
}
